const todoListInterface = {
    renamingList: false,
    deletingList: false,
    creatingTodo: false,
    showingCompleted: false,
    activeList: 1,
    creatingList: false,
    showingImportant: false,
    showingAllTasks: false,
    search: "",
}
export default todoListInterface;
